/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dull_Yummy_Osprey_WalkInputs */

const fr_dull_yummy_osprey_walk = /** @type {(inputs: Dull_Yummy_Osprey_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de WOD`)
};

/**

* @param {Dull_Yummy_Osprey_WalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dull_yummy_osprey_walk = /** @type {((inputs?: Dull_Yummy_Osprey_WalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dull_Yummy_Osprey_WalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dull_yummy_osprey_walk(inputs)
});